export class QPageProps {
  constructor() {
    this.fPageWidth = null;
    this.fPageHeight = null;
    this.fPageOrientation = null;
    //this.fAutoSizePDF = null;

    this.fMargins = null;
    this.fShowMargins = true;
    this.fHeaderHeight = null;
    this.fFooterHeight = null;
    this.fShowHeaderFooter = true;

    this.fBackgroundColor = null;
    this.fBackgroundColor2 = null;

    this.fBackgroundFillMode = null;
  }
}
